import { useActionCreators } from 'app/area/case-report/case-listing/hooks';
import { selectLayoutTypes } from 'app/area/case-report/case-listing/selectors';
import { dashboardLayoutTypeContext } from 'app/area/dashboard/constants';
import {
  useAutoExecuteContext, useInstanceKey, useInstanceOptions
} from 'app/area/favourite/favourite-context';
import { selectLayoutTypeForSelectedReport, selectSelectedReport } from 'app/area/favourite/selectors';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export function useAutoExecuteState() {
  const autoExecuteContext = useAutoExecuteContext();
  const [autoExecute, setAutoExecute] = useState(autoExecuteContext.current);

  const toggleAutoExecution = useCallback(() => {
    setAutoExecute(!autoExecute);
    autoExecuteContext.current = !autoExecute;
  }, [autoExecute]);

  return {
    autoExecute,
    toggleAutoExecution
  };
}

export function useLayoutTypesEffect() {
  const instanceKey = useInstanceKey();
  const { hideVisualizationOptions } = useInstanceOptions();
  const selectedReport = useSelector(selectSelectedReport(instanceKey));
  const layoutTypes = useSelector(selectLayoutTypes(instanceKey));
  const selectedLayoutType = useSelector(selectLayoutTypeForSelectedReport(instanceKey));
  const { layoutTypeContextId } = useInstanceOptions();
  const { loadLayoutTypes, setLayoutType } = useActionCreators();

  useEffect(() => {
    if (layoutTypeContextId !== dashboardLayoutTypeContext) {
      loadLayoutTypes(selectedReport?.v);
    }
  }, [loadLayoutTypes, selectedReport?.v]);

  return {
    layoutTypes,
    selectedLayoutType: selectedLayoutType ? codeItemToStoreValue(selectedLayoutType) : null,
    setLayoutType,
    hideVisualization: hideVisualizationOptions,
    layoutTypeContextId
  };
}
